// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-catalog-__slug-indexstyleGrid-container-lvxqc{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-catalog-__slug-indexstyleGrid-grid-cdgkh{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-catalog-__slug-indexstyleGrid-col6-cdwzc{grid-column:span 6}.pages-catalog-__slug-indexstyleGrid-col3-bzqlu{grid-column:span 3}.pages-catalog-__slug-indexstyleGrid-col4-btguf{grid-column:span 4}.pages-catalog-__slug-indexstyleGrid-col9-bfjtt{grid-column:span 9}.pages-catalog-__slug-indexstyleGrid-col12-tprco{grid-column:span 12}.pages-catalog-__slug-indexstyleGrid-alignItemsStart-jumbq{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-catalog-__slug-indexstyleGrid-container-lvxqc",
	"grid": "pages-catalog-__slug-indexstyleGrid-grid-cdgkh",
	"col6": "pages-catalog-__slug-indexstyleGrid-col6-cdwzc",
	"col3": "pages-catalog-__slug-indexstyleGrid-col3-bzqlu",
	"col4": "pages-catalog-__slug-indexstyleGrid-col4-btguf",
	"col9": "pages-catalog-__slug-indexstyleGrid-col9-bfjtt",
	"col12": "pages-catalog-__slug-indexstyleGrid-col12-tprco",
	"alignItemsStart": "pages-catalog-__slug-indexstyleGrid-alignItemsStart-jumbq"
};
module.exports = ___CSS_LOADER_EXPORT___;
